import { defineMessages } from 'react-intl';

export const FooterMessages = defineMessages({
  Title: {
    id: 'footer_title',
    defaultMessage:
      'FHNW University of Applied Sciences and Arts Northwestern Switzerland',
  },
  ToTop: {
    id: 'footer_to_top',
    defaultMessage: 'Go to top of page',
  },
  Copyright: {
    id: 'footer_copyright_notice',
    defaultMessage:
      '© University of Applied Sciences and Arts Northwestern Switzerland (FHNW)',
  },
  SignUpMessage: {
    id: 'footer_sign_up_message',
    defaultMessage:
      'Sign up for our newsletter and benefit from exclusive insights.',
  },
  SignUpLabel: {
    id: 'footer_sign_up_label',
    defaultMessage: 'Sign up for Newsletter',
  },
});
